import axios from "axios";

export default axios.create({
    // baseURL: "http://127.0.0.1:8000"
    //baseURL: "http://10.4.8.168:8000"
    baseURL: "https://unau.mlhuillier.net"
})
